export default __webpack_public_path__ + "card2.png";